// removed by extract-text-webpack-plugin
module.exports = {"this":"Emoji__this___2hD4_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/styles/Emoji.css
// module id = 995
// module chunks = 4